import type { Post } from '@/@types/post'
import clsx from 'clsx'
import type { HTMLAttributes } from 'react'
import Avatar from '../../Avatar'
import styles from './PostCard.module.css'

export interface PostCardProps extends HTMLAttributes<HTMLDivElement> {
	data: Post
}

export default function PostCard({ data, className, ...props }: PostCardProps) {
	return (
		<div
			className={clsx(styles.root, className)}
			data-anonymous-gated-interaction={Boolean(props.onClick) || undefined}
			{...props}
		>
			<main className={styles.main}>
				<Avatar data={data.user} className={styles.avatar} />
				<div className={styles.content}>
					{data.user?.screenName}:{data.content ?? ''}
				</div>
			</main>
			{data.topic?.content && <footer className={styles.footer}>{data.topic.content}</footer>}
		</div>
	)
}
